// extracted by mini-css-extract-plugin
export default {"contact_person_container":"style_contact_person_container__hVsw8","no_margin":"style_no_margin__+I+Eq"};